export const SKIP_CHANNEL_DETAILS_REQUEST = 'SKIP_CHANNEL_DETAILS_REQUEST';
export const SKIP_CHANNEL_DETAILS_SUCCESS = 'SKIP_CHANNEL_DETAILS_SUCCESS';
export const SKIP_CHANNEL_DETAILS_FAILURE = 'SKIP_CHANNEL_DETAILS_FAILURE';
export const skipChannelDetailsSuccess = (payload) => ({
    type: SKIP_CHANNEL_DETAILS_SUCCESS,
    payload,
});
export const skipChannelDetailsRequest = (payload) => ({
    type: SKIP_CHANNEL_DETAILS_REQUEST,
    payload,
});
export const skipChannelDetailsFailure = (payload) => ({
    type: SKIP_CHANNEL_DETAILS_FAILURE,
    payload,
});
